import React from "react"
import { Grid, Segment, Divider, Item, Form } from "semantic-ui-react"
import { Redirect, Link } from "react-router-dom"
import { callService, POST } from "../../shared/serviceInvoker";
import { loginURL } from "../../shared/urls/clientapi";
import {checkEmail, checkMinLength, checkRequired} from "../../shared/helpers/validators";
import { overviewURL } from "../../shared/urls/app";
import { signIn } from "../../shared/auth";
import TermsAndPrivacy from "../../shared/components/TermsAndPrivacy";
import AllRightsReserved from "../../shared/components/AllRightsReserved";
import CompanyLogo from "../../shared/components/CompanyLogo";
import * as utils from "../../shared/utils"
import MessageError from "../../shared/components/MessageError"
import ReactGA from 'react-ga';
import { trackEvent } from '../../shared/tracking';

const errors = {
  passwordLength: 'Password must be at least 8 characters.',
  passwordRequired: 'Password is required.',
  emailValid: 'Invalid email address.',
  emailRequired: 'Email is required.',
};

export default class Login extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      redirectToReferrer: false,
      email: '',
      password: '',

      passwordLength: true,
      passwordRequired: true,
      emailValid: true,
      emailRequired: true,

      formValid: false,

      showInvalidLogin: false
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.validateField = this.validateField.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState(
      {[name]: value},
      () => {this.validateField(name, value)}
    );
  }

  validateField(fieldName, value) {
    let passwordLength = this.state.passwordLength;
    let passwordRequired = this.state.passwordRequired;
    let emailValid = this.state.emailValid;
    let emailRequired = this.state.emailRequired;
    switch(fieldName) {
      case 'password':
        passwordRequired = checkRequired(value);
        passwordLength = checkMinLength(value, 8);
        break;
      case 'email':
        emailRequired = checkRequired(value);
        emailValid = checkEmail(value);
        break;
      default:
        break;
    }
    this.setState(
      {
        passwordLength: passwordLength,
        passwordRequired: passwordRequired,
        emailValid: emailValid,
        emailRequired: emailRequired,
      },
      this.validateForm
    )
  }

  validateForm() {
    this.setState(
      {
        formValid: this.state.passwordLength && this.state.passwordRequired &&
        this.state.emailValid && this.state.emailRequired
      }
    )
  }

  handleSubmit(event) {
    event.preventDefault();
    const {email, password} = this.state;
    let bodyFormData = new FormData();

    bodyFormData.append('email', email);
    bodyFormData.append('password', password);
    callService(
      POST,
      loginURL,
      bodyFormData,
      response => {
        signIn();
        sessionStorage.setItem("first_name", response.data.data.first_name);
        sessionStorage.setItem("contact_id", response.data.data.contact_id);
        sessionStorage.setItem("user_id", response.data.data.user_id);
        sessionStorage.setItem("autoplay_launched", 'false');
        this.setState({ showInvalidLogin: false, redirectToReferrer: true });

        ReactGA.set({ userId: response.data.data.contact_id });
        ReactGA.ga('set', 'dimension1', response.data.data.contact_id.toString());
        ReactGA.event({
          category: 'Navigation',
          action: 'User Logged In',
        });
        trackEvent('Navigation', 'User Logged In');
      },
      error => {
        this.setState({ showInvalidLogin: true });
      }
    );
  }

  render() {
    const { from } = { from: { pathname: overviewURL } };
    const {
      redirectToReferrer,
      password,
      email,
      emailValid,
      emailRequired,
      passwordRequired,
      passwordLength,
      formValid
    } = this.state;

    if (redirectToReferrer) {
      return <Redirect to={from} />;
    }

    if (utils.isUserAuthenticated() === true) {
      return <Redirect to={{ pathname: overviewURL }} />;
    }

    return (
      <div className='form'>
        <style>{`
            body > div,
            body > div > div,
            body > div > div > div.form {
              height: 100%;
              background-color: #f2f2f2;
            }
          `}</style>
        <Grid textAlign='center' style={{ height: '100%' }} verticalAlign='middle'>
          <Grid.Column style={{ maxWidth: 450 }}>
            <CompanyLogo />
            <Segment>
              {
                this.state.showInvalidLogin ?
                  <p>
                    <MessageError message="Sorry, we weren't able to find that combination." />
                  </p>  
                  :
                  null
              }
              <Form onSubmit={this.handleSubmit}>
                <Item style={{ textAlign: 'left' }}>Email</Item>
                <Form.Input 
                  fluid icon='mail'
                  iconPosition='left'
                  name='email'
                  placeholder="Enter your email"
                  value={email}
                  onChange={this.handleInputChange}
                  error={!(emailRequired && emailValid)} />
                <Item style={{color: 'red'}}>
                  {!emailRequired && <div>{errors.emailRequired}</div>}
                  {!emailValid && <div>{errors.emailValid}</div>}
                </Item>                
                <Item style={{ textAlign: 'left' }}>Password</Item>
                <Form.Input 
                  fluid
                  icon='lock'
                  iconPosition='left'
                  type='password'
                  name='password'
                  placeholder="Enter your password"
                  password='true'
                  value={password}
                  onChange={this.handleInputChange}
                  error={!(passwordLength && passwordRequired)} />
                <Item style={{color: 'red'}}>
                  {!passwordLength && <div>{errors.passwordLength}</div>}
                  {!passwordRequired && <div>{errors.passwordRequired}</div>}
                </Item>  
                <Form.Button color='blue' fluid size='large' icon='lock' content='Sign In' disabled={!formValid} /> 
                <TermsAndPrivacy btnContent="Sign In" />
              </Form>
              <Divider />
              <Item as={Link} to='/passwordhelp'>I don't know my password</Item>
            </Segment>
            <Divider hidden />
            <AllRightsReserved />
          </Grid.Column>
        </Grid>
      </div>
    );
  }
}





// WEBPACK FOOTER //
// ./src/components/Login/index.js